module.exports = __webpack_public_path__ + "img/tpm-black.fe89ab28.svg";